let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aX7r6")).then(() => parcelRequire('7B9bx'));